import ajax from './ajax';
import { API_DOMAIN, API_MANAGE_DOMAIN } from '../utils/constants';



export const create_update_app = (params) => ajax(API_DOMAIN + '/api/a/b/c-a-i', params, 'POST');
export const query_app = (params) => ajax(API_DOMAIN + '/api/a/b/q-app', params, 'POST');
export const adming_login = (params) => ajax(API_DOMAIN + '/api/a/b/ad-login', params, 'POST');
export const admin_context = (params) => ajax(API_DOMAIN + '/api/a/b/context', params, 'POST');
export const admin_store_performance = (params) => ajax(API_DOMAIN + '/api/a/b/store-performance', params, 'POST');
export const admin_shops = (params) => ajax(API_DOMAIN + '/api/a/b/admin-shops', params, 'POST');
export const admin_accounts = (params) => ajax(API_DOMAIN + '/api/a/b/admin-accounts', params, 'POST');
export const create_admin_account = (params) => ajax(API_DOMAIN + '/api/a/b/admin-accounts/create', params, 'POST', 'json');
export const update_admin_account = (params) => ajax(API_DOMAIN + '/api/a/b/admin-accounts/update', params, 'POST', 'json');
export const q_e_log = (params) => ajax(API_DOMAIN + '/api/a/b/q_e_log', params, 'POST');
export const d_e_log = (params) => ajax(API_DOMAIN + '/api/a/b/d_e_log', params, 'POST');
export const query_shop_links = (params) => ajax(API_DOMAIN + '/api/a/b/q-shop-links', params, 'POST');
export const create_update_shop_link = (params) => ajax(API_DOMAIN + '/api/a/b/c-u-shop-link', params, 'POST');
export const sync_shop_link = (params) => ajax(API_DOMAIN + '/api/a/b/sync-shop-link', params, 'POST');
